import { BROADCAST_SET_MULTIPLE_DESIRED_ATTENDEE_MUTE_STATUSES } from 'actions/Types';
import {
  MULTIPLE_MUTE_CHANGE,
  MULTIPLE_ATTENDEE_MIC_STATUSES_CHANGE
} from 'store/eventConstants';
import { UNASSIGNED } from 'utils/broadcastSourceHelper';

/*
With this action, we send a socket to attendees to toggle their mics,
We update the reducer for unassigned presenter in the payload.
This is because assigned presenters will update their states by
the chime observer when the mic toggle action is successful
*/
export default muteStatuses => {
  return (dispatch, getState, socket) => {
    const { broadcast } = getState();
    let unassignedMuteStatuses = {};

    const action = {
      type: BROADCAST_SET_MULTIPLE_DESIRED_ATTENDEE_MUTE_STATUSES,
      request: async () => {
        const payload = {
          muteStatuses,
          broadcastId: broadcast && broadcast._id
        };
        socket.emit(MULTIPLE_MUTE_CHANGE, payload);
        unassignedMuteStatuses = filterUnassignedSources(muteStatuses);
        // this socket updates the mic state for unassigned sources for multiple directors
        socket.emit(MULTIPLE_ATTENDEE_MIC_STATUSES_CHANGE, {
          muteStatuses: unassignedMuteStatuses,
          broadcastId: broadcast && broadcast._id
        });
        return Object.create(null);
      },
      payload: unassignedMuteStatuses
    };

    dispatch(action);
  };
};

function filterUnassignedSources(muteStatuses) {
  return Object.keys(muteStatuses)
    .filter(key => key.includes(UNASSIGNED))
    .reduce((obj, key) => {
      return Object.assign(obj, {
        [key]: muteStatuses[key]
      });
    }, {});
}
